import React from "react"
import clsx from "clsx"
// import AddButtonNew from "../../AddButton/AddButtonNew";
// import AddButton from "../../AddButton/AddButton"

class AdditionalCustomerFieldBuilderOptions extends React.Component {
  
  constructor(props) {
    super(props)
  }

  /** Render Functions **/

  render() {

    var tabClasses = clsx({
      'active': this.props.active_tab == 'options',
      'tab-pane': true
    })

    return (
      <div className={tabClasses} id="options">
      <div className="row">
        <div className="col-md-12">
          {/* { this.renderErrors() } */}
          <div className="panel panel-default" style={{marginBottom: 0}}>
            <div className="panel-heading flexed add-button-pannel">
              <div className="col-md-6">
                <h3 className="panel-title">
                  {`${I18n.t('options')}*`} <span className="ss-help help" title={I18n.t('click_add_button')}></span>
                </h3>
              </div>
              {this.renderAddButton()}
            </div>
            <div className="panel-body flexed">
              {this.renderOptions()}
            </div>           
          </div>
        </div>
      </div>
    </div>
      
      // <div className={tabClasses} id="options">
      //   {this.renderAddButton()}    
      //   {this.renderOptions()}
      //   <hr />
      // </div>
    )
  }

  renderOptions() {
    if(this.props.options && this.props.options.length >= 1) {
      var options = this.props.options.map((option, idx) => {
        return (
          <div key={idx} className="row option-wrapper" style={{flexWrap:"nowrap"}} >
            <div className='col-md-4 form-inline' style={{paddingTop:'10px', paddingBottom:'10px' ,flexFlow:'nowrap'}}>
              <label style={{padding: '10px', margin: '5px', font:'14px'}}>{I18n.t('option') + ' ' + option.position + ':'}</label>
              <input id={option.position} className="form-control" style={{width: '100%'}}  value={option.option} onChange={this.props.onChangeOption} />
            </div>
            <div className='col-md-8 form-group flexed content-right' style={{paddingTop:"10px"}}>
              {this.renderRemoveButton(option.position)}
            </div>
          </div>
        )
      })
    } else {
      return (
        <div className="no-records col-md-12">
          <span className="none">{I18n.t('none')}</span>
        </div>
      )
    }
    return (
      <div className="card col-md-12">
        {options}
      </div>
    )
  }

  renderAddButton() {
    return (

      // <div className="card card-md">
      //   <div className="col-md-6">
      //     <p>{I18n.t('click_add_button')}</p>
      //   </div>
        <div className="col-md-6 flexed content-right">
          <button className="btn btn-secondary" onClick={this.props.onClickAddOption}>{I18n.t('add')}</button>
        </div>
      // </div>
    );
  };

  renderRemoveButton(option) {
    return (
      <button className="btn btn-secondary option-remove-btn" id={option} onClick={this.props.onClickRemoveOption}>{I18n.t('remove')}</button>
    );
  };

};

export default AdditionalCustomerFieldBuilderOptions